import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate } from "react-router-dom";
const Header = ({ setShowPlanner }) => {
    const navigator = useNavigate();
    const [expanded, setExpanded] = useState(false);

    const handleNavClick = (path) => {
        navigator(path);
        setExpanded(false); // Close the navbar
    };
    return (
        <>
            <Navbar collapseOnSelect expand="sm" className="bg-body-tertiary" expanded={expanded}>
                <Container>
                    <Navbar.Brand href="#home">Plan your way</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)} />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <NavDropdown title="Planner pages" id="collapsible-nav-dropdown">
                                <NavDropdown.Item onClick={() => { handleNavClick('/template') }}>Template Selection</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={() => handleNavClick('/colorSelection')}>Color Selection</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={() => handleNavClick('/font')}>Font Selection</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link href="#features">Owner Log in</Nav.Link>

                        </Nav>

                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}
export default Header;